import React, { useState } from 'react';
import './Header.css';
import shef from '../assets/shef.png';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';

const Header: React.FC = () => {
  const { t } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>, section: string) => {
    e.preventDefault();

    if (location.pathname === '/') {
      // Aynı sayfadaysa direkt scroll
      const el = document.querySelector(section);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    } else {
      // Başka sayfadaysa flag gönder
      navigate('/', { state: { scrollTo: section } });
    }

    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          {/* Logo */}
          <div className="logo" onClick={() => navigate('/')}>
            <img width={22} height={30} src={shef} alt="FoodQuick" className="logo-image" />
            <span className="logo-text">FoodQuick</span>
          </div>

          {/* Navigation */}
          <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
            <a href="#features" className="nav-link" onClick={(e) => handleLinkClick(e, '#features')}>
              {t('header.features')}
            </a>
            <a href="#recipes" className="nav-link" onClick={(e) => handleLinkClick(e, '#recipes')}>
              {t('header.recipes')}
            </a>
            <a href="#download" className="nav-link" onClick={(e) => handleLinkClick(e, '#download')}>
              {t('header.download')}
            </a>
            <a href="#contact" className="nav-link" onClick={(e) => handleLinkClick(e, '#contact')}>
              {t('header.contact')}
            </a>
          </nav>

          {/* Mobile Menu Toggle */}
          <button className="menu-toggle" onClick={toggleMenu}>
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
